'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var axios = _interopDefault(require('axios'));
var _ = _interopDefault(require('lodash'));
var Cookies = _interopDefault(require('js-cookie'));

var api = {
  async request({uri, body={}}, {token, shouldAlert=true}={}) {
    var domain = {
      development: 'http://localhost:3301',
      production: 'https://symbolic-frameworks-api.herokuapp.com'
    }[process.env.NODE_ENV];

    var url = `${domain}${uri}`;

    body.token = body.token || token || global.sessionToken || Cookies.get('sessionToken');

    try {
      var response = await axios.post(url, body);
    }
    catch (error) {
      if (shouldAlert) {
        alert(_.join(_.map(error.response.data.errors, 'message'), `\n`));
      }

      throw error;
    }

    return response;
  },

  async resources(resources, options) {
    var response = await api.request({uri: '/resources', body: {resources}}, options);

    return _.get(response, 'data');
  },

  async act(actionKey, resourceKey, params={}, options) {
    var response = await api.resources({[actionKey]: {[resourceKey]: params}}, options);

    return _.get(response, `data.resources.${actionKey}.${resourceKey}`);
  },

  get(...args) {
    return api.act('get', ...args);
  },

  create(resourceKey, props={}, ...args) {
    return api.act('create', resourceKey, {props}, ...args);
  },

  update(...args) {
    return api.act('update', ...args);
  },

  destroy(...args) {
    return api.act('destroy', ...args);
  }
};

var colors = {};

colors.subdued = [
  'rgb(187, 205, 229)',
  'rgb(187, 191, 229)',
  'rgb(200, 187, 229)',
  'rgb(216, 187, 229)',
  'rgb(229, 187, 205)',
  'rgb(229, 187, 187)',
  'rgb(229, 200, 187)',
  'rgb(229, 211, 187)',
  'rgb(207, 229, 187)',
  'rgb(188, 229, 187)',
  'rgb(187, 229, 205)',
  'rgb(187, 229, 222)',
  'rgb(187, 228, 229)',
];

colors.fun = [
  'rgb(135, 178, 246)',
  'rgb(135, 146, 246)',
  'rgb(168, 135, 246)',
  'rgb(207, 135, 246)',
  'rgb(242, 135, 246)',
  'rgb(246, 135, 165)',
  'rgb(246, 135, 135)',
  'rgb(246, 148, 135)',
  'rgb(246, 179, 135)',
  'rgb(246, 207, 135)',
  'rgb(135, 246, 146)',
  'rgb(158, 224, 192)',
  'rgb(135, 246, 178)',
  'rgb(135, 246, 215)',
  'rgb(135, 246, 240)',
  'rgb(135, 222, 246)',
  'rgb(135, 192, 246)'
];

colors.statuses = {
  active: 'rgb(199, 223, 240)',
  none: 'rgb(216, 216, 216)',
  blocked: 'rgb(247, 170, 170)',
  complete: 'rgb(218, 234, 201)',
  snoozed: 'rgb(245, 202, 112)'
};

colors.all = [
  ...colors.subdued,
  ...colors.fun,
  ...(Object.values ? Object.values(colors.statuses) : [])
];

var sf = {api, colors};

exports.api = api;
exports.colors = colors;
exports.default = sf;
